
    window.addEventListener('load', () => {
      const loader = document.getElementById('initial-preloader');
      if (loader) {
        setTimeout(() => {
          loader.style.opacity = '0';
          setTimeout(() => loader.remove(), 400);
        }, 300);
      }
    });
  